import { api_subscribe_path } from '../../routes';
import request from './request';

export const ANNUAL_REFERRAL_OFFER = 'annual-trial-14-referral';
export const DEFAULT_ANNUAL_PRICE = 399;
export const DEFAULT_MONTHLY_PRICE = 39;
export const DEFAULT_PRO_PRICE = 999;
export const DISCOUNTED_PRO_PRICE = 749;
export const DISCOUNTED_REFERRAL_PRICE = 299;
export const SPECIAL_OFFER_PRICE = 199;
export const YOUNG_PROFESSIONALS_PRICE = 199;

export const REFERRAL_ANNUAL = {
  cycle: 'year',
  plan: ANNUAL_REFERRAL_OFFER,
  total: {
    label: `Annual Subscription with 14 Days Trial ($${DISCOUNTED_REFERRAL_PRICE}.00 after free trial)`,
    amount: 0,
  },
  price: DISCOUNTED_REFERRAL_PRICE,
};

export interface CurrentPlanSelection {
  cycle: string;
  plan: string;
  total: {
    label: string;
    amount: number;
  };
  price: number;
}

export interface SubscribeUserParams {
  email: string;
  name: string;
  password: string;
  stripe_nonce: string;
  plan: string;
  recaptcha_token: string;
  referrer: string;
}

export async function subscribeUser(params: SubscribeUserParams) {
  const resp = await request('post', api_subscribe_path(params));
  return resp;
}
